import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'

import { AssetsContext } from '../../context'
import { ASIDE_VIEWS } from '.'
import { humanizeString } from '@utils/stringMinipulation'
import bannerImg from '@assets/images/general_banner_img.png'

export const Aside = ({ asideView }) => {
  switch (asideView) {
    case ASIDE_VIEWS.DEFAULT_LIVING_ANNUITY_EXPLANATION:
      return <AsideInfo 
        title='Default Living Annuity'
        Content={ () =>
          <>
            <p>The system living annuity is a default Living Annuity that is created by our system in alignment with the client's risk profile.</p>
            <p>This living annuity is primarily used as the recipient for all funds from retirement assetts when they mature; such as retirement annuities, pensions, and provident funds.</p>
          </>
        }
      />
    case ASIDE_VIEWS.DEFAULT_UNIT_TRUST_EXPLANATION:
      return <AsideInfo 
        title='Default Unit Trust'
        Content={ () =>
          <>
            <p>The system unit trust is a default Unit Trust that is created by our system in alignment with the client's risk profile.</p>
            <p>This unit trust is used primarily for the lump sum withdrawal at retirement.</p>
          </>
        }
      />
    case ASIDE_VIEWS.CASH_WITHDRAWAL_EXPLANATION:
      return <AsideInfo 
        title='Cash withdrawal'
        Content={ () =>
          <>
            <p>The cash withdrawal option assumes that the lump sum of a retirement asset is taken as cash and not reinvested.</p>
            <p> Currently, the cash withdrawal is assumed to be the full lump sum amount and will not reflect on the income graph.</p>
          </>
        }
      />
    default: 
      return <DefaultAside /> 
  }
}

const DefaultAside = () => {
  const { state } = useContext(AssetsContext)
  const { formAssetType } = state

  return (
  <section className='info-section hidden lg:block'>
    <h3>Add your <strong>{humanizeString(formAssetType)}</strong> information here.</h3>
    <img src={bannerImg} />
  </section>
  )
}

const AsideInfo = ({ title, Content }) => {
  return (
    <Box
      m='1rem'
    >
      <Box
        position={'sticky'}
        top='100px'
      >
        <h3>{title}</h3>
        <Content />
      </Box>
    </Box>
  )
}
